// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1oj7i","question":"Question_question__3dmn-","description":"Question_description__22SSC"};